import React from 'react';
import {
  PageSplitHorizontal,
  PageSplitVertical,
  ScrollableViewport,
  ComponentWrapper,
} from '@ihsm/ui-shared';

interface ThreePartSplitProps {
  topLeft: React.FC | React.ReactNode | React.ReactElement;
  topRight: React.FC | React.ReactNode | React.ReactElement;
  bottom: React.FC | React.ReactNode | React.ReactElement;
}

export const ThreePartSplit: React.FC<ThreePartSplitProps> = ({
  topLeft,
  topRight,
  bottom,
}): JSX.Element => (
  <PageSplitHorizontal
    top={
      <PageSplitVertical
        left={
          <ScrollableViewport vertical horizontal>
            <ComponentWrapper component={topLeft} />
          </ScrollableViewport>
        }
        right={
          <ScrollableViewport vertical horizontal>
            <ComponentWrapper component={topRight} />
          </ScrollableViewport>
        }
      />
    }
    bottom={
      <ScrollableViewport vertical horizontal>
        <ComponentWrapper component={bottom} />
      </ScrollableViewport>
    }
  />
);
